import { render } from "./MessageError.vue?vue&type=template&id=a2960578"
import script from "./MessageError.vue?vue&type=script&lang=js"
export * from "./MessageError.vue?vue&type=script&lang=js"

import exportComponent from "C:\\MartinRud-CloudRoot\\Firma\\Code\\PHP\\byensegenbil.dk\\byensegenbil.dk-2024\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__